import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
} from '@mui/material';
import { Integration } from '../../types';

interface EditIntegrationDialogProps {
  open: boolean;
  loading: boolean;
  integration: Integration | null;
  onClose: () => void;
  onSubmit: (frontUrl: string, senderName: string, smsKey: string) => void;
}

export const EditIntegrationDialog: React.FC<EditIntegrationDialogProps> = ({
  open,
  loading,
  integration,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [frontUrl, setFrontUrl] = useState('');
  const [senderName, setSenderName] = useState('');
  const [smsKey, setSmsKey] = useState('');

  useEffect(() => {
    if (open && integration) {
      setFrontUrl(integration.front_url || '');
      setSenderName(integration.sender?.name || '');
      setSmsKey(integration.sender?.sms_key || '');
    }
  }, [open, integration]);

  const handleSubmit = () => {
    onSubmit(frontUrl.trim(), senderName.trim(), smsKey.trim());
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {t('IntegrationsPage.EditDialog.TITLE', {
          code: integration?.code || '',
        })}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label={t('IntegrationsPage.EditDialog.FRONT_URL_LABEL')}
            fullWidth
            value={frontUrl}
            onChange={(e) => setFrontUrl(e.target.value)}
            disabled={loading}
            size="small"
            placeholder="https://partner.example.com"
          />
          <TextField
            label={t('IntegrationsPage.EditDialog.SENDER_NAME_LABEL')}
            fullWidth
            value={senderName}
            onChange={(e) => setSenderName(e.target.value)}
            disabled={loading}
            size="small"
          />
          <TextField
            label={t('IntegrationsPage.EditDialog.SMS_KEY_LABEL')}
            fullWidth
            value={smsKey}
            onChange={(e) => setSmsKey(e.target.value)}
            disabled={loading}
            size="small"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          {t('IntegrationsPage.Common.CANCEL')}
        </Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained">
          {t('IntegrationsPage.EditDialog.SUBMIT')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditIntegrationDialog;
